<template>
    <button @click.prevent="handleClick" type="button" :disabled="loading">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
             xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" :fill="likedC && '#FF394F'"
                  d="M11.761 20.8538C9.5904 19.5179 7.57111 17.9456 5.73929 16.1652C4.45144 14.8829 3.47101 13.3198 2.8731 11.5954C1.79714 8.25031 3.05393 4.42083 6.57112 3.28752C8.41961 2.69243 10.4384 3.03255 11.9961 4.20148C13.5543 3.03398 15.5725 2.69398 17.4211 3.28752C20.9383 4.42083 22.2041 8.25031 21.1281 11.5954C20.5302 13.3198 19.5498 14.8829 18.2619 16.1652C16.4301 17.9456 14.4108 19.5179 12.2402 20.8538L12.0051 21L11.761 20.8538Z"
                  stroke="#212529" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round"/>
            <path d="M15.7383 7.05322C16.8036 7.39352 17.5605 8.34992 17.6551 9.4752"
                  stroke="#212529" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round"/>
        </svg>

        {{ likeCountC === false ? '' : toFaNum(likeCountC) }}

    </button>
</template>

<script>
import {mapState} from "vuex";

export default {
    props: {
        likeCount: [Number, Boolean],
        liked: Boolean,
        slug: String,
    },

    data() {
        return {
            loading: false,
            likeCountC: this.likeCount,
            likedC: this.liked,
        }
    },

    computed: {
        ...mapState('auth', [
            'user'
        ]),
    },

    methods: {
        like() {
            axios.post(`/api/v1/index/products/${this.slug}/like`)
                .then(() => {
                    this.likedC = true
                    if (this.likeCountC !== false) {
                        this.likeCountC++
                    }
                }).catch(() => {

                }).then(() => {
                    this.loading = false
                })
        },
        unlike() {
            axios.post(`/api/v1/index/products/${this.slug}/unlike`)
                .then(() => {
                    this.likedC = false
                    if (this.likeCountC !== false) {
                        this.likeCountC--
                    }
                }).catch(() => {

            }).then(() => {
                this.loading = false
            })
        },
        handleClick() {
            if (!this.user) {
                window.location = '/login'
                return
            }

            if (this.loading) {
                return
            }
            this.loading = true
            return this.likedC ? this.unlike() : this.like()
        }
    }
}
</script>

<style scoped>

</style>
